module.exports = __webpack_public_path__ + "static/media/download.678878b0.svg";